export const MAX_ITERATION_COUNT = 1000

export function normalizeLegacyIterationCount(iterationCount: unknown): number {
  const numericValue =
    typeof iterationCount === "number"
      ? iterationCount
      : typeof iterationCount === "string" && iterationCount.trim() !== ""
        ? Number(iterationCount)
        : Number.NaN

  if (!Number.isFinite(numericValue)) {
    return 1
  }

  const integerValue = Math.trunc(numericValue)

  if (integerValue < 1) {
    return 1
  }

  if (integerValue > MAX_ITERATION_COUNT) {
    return MAX_ITERATION_COUNT
  }

  return integerValue
}
